
<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1>News Analysis </h1>
                </div>
            </div>
        </div>
    </div>
</section>
<section class>
    <div class="section-lg">
        <div class="container">
            <!-- <div class="text-justify">
                <p>GHRCACS, Nagpur, proudly organised Deep Milan, a vibrant celebration of lights, unity, and togetherness. Bringing together students, faculty, and traditions, this event marked a memorable evening filled with joy and festivity. </p>
            </div> -->
            <div class="row mb-20 mt-5">
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a
                            href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/news-analysis-1.avif"
                            data-lightbox="example-set"
                            data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/news-analysis-1.avif"
                                alt="News Analysis | Ghrcacsn" title="News Analysis | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a
                            href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/news-analysis-2.avif"
                            data-lightbox="example-set"
                            data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/news-analysis-2.avif"
                                alt="News Analysis | Ghrcacsn" title="News Analysis | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a
                            href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/news-analysis-3.avif"
                            data-lightbox="example-set"
                            data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/news-analysis-3.avif"
                                alt="News Analysis | Ghrcacsn" title="News Analysis | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a
                            href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/news-analysis-5.avif"
                            data-lightbox="example-set"
                            data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/news-analysis-5.avif"
                                alt="News Analysis | Ghrcacsn" title="News Analysis | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a
                            href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/news-analysis-6.avif"
                            data-lightbox="example-set"
                            data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/news-analysis-6.avif"
                                alt="News Analysis | Ghrcacsn" title="News Analysis | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a
                            href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/news-analysis-7.avif"
                            data-lightbox="example-set"
                            data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/news-analysis-7.avif"
                                alt="News Analysis | Ghrcacsn" title="News Analysis | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a
                            href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/news-analysis-8.avif"
                            data-lightbox="example-set"
                            data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/news-analysis-8.avif"
                                alt="News Analysis | Ghrcacsn" title="News Analysis | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a
                            href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/news-analysis-9.avif"
                            data-lightbox="example-set"
                            data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/news-analysis-9.avif"
                                alt="News Analysis | Ghrcacsn" title="News Analysis | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a
                            href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/news-analysis-10.avif"
                            data-lightbox="example-set"
                            data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/news-analysis-10.avif"
                                alt="News Analysis | Ghrcacsn" title="News Analysis | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a
                            href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/news-analysis-11.avif"
                            data-lightbox="example-set"
                            data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/news-analysis-11.avif"
                                alt="News Analysis | Ghrcacsn" title="News Analysis | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a
                            href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/news-analysis-12.avif"
                            data-lightbox="example-set"
                            data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/news-analysis-12.avif"
                                alt="News Analysis | Ghrcacsn" title="News Analysis | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a
                            href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/news-analysis-13.avif"
                            data-lightbox="example-set"
                            data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/news-analysis-13.avif"
                                alt="News Analysis | Ghrcacsn" title="News Analysis | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
               
            </div>
        </div>
    </div>
</section>
